import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormMode } from 'app/core/constants/form-mode';

@Component({
  selector: 'app-process-category-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './process-category-form.component.html'
})
export class ProcessCategoryFormComponent {
  categoryForm = input.required<FormGroup>();
  mode = input.required<FormMode>();
  formMode = FormMode;
}
